// import React, { useContext, useEffect, useState } from "react";
// import axios from "axios";
// import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
// import { FiPlus } from "react-icons/fi";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { XMarkIcon } from "@heroicons/react/24/solid";
// import { toast } from "react-toastify";

// const SmsTemplate = () => {
//   const { user } = useContext(AuthContext);
//   const companyId =
//     user?.accountType === "COMPANY" ? user?.id : user?.companyId;

//   const [templates, setTemplates] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [isEdit, setIsEdit] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [formData, setFormData] = useState({
//     senderId: "",
//     templateId: "",
//     templateType: "",
//     templateText: "",
//     companyId: companyId,
//   });
//   const [availableVariables, setAvailableVariables] = useState([]);
//   const [variables, setVariables] = useState([]);
//   const [deleteId, setDeleteId] = useState(null);
//   const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);

//   const headers = {
//     Authorization: `Bearer ${localStorage.getItem("token")}`,
//   };

//   const fetchTemplates = async () => {
//     try {
//       const res = await axios.get(
//         `${API_URL}/api/smsTemplates/company/${companyId}`,
//         { headers }
//       );
//       setTemplates(res.data.smsTemplates);
//     } catch (err) {
//       console.error("Error fetching templates:", err);
//     }
//   };

//   useEffect(() => {
//     fetchTemplates();
//   }, []);

//   const addVariable = () => {
//     const newVar = `var${availableVariables.length + 1}`;
//     setAvailableVariables((prev) => [...prev, newVar]);
//     setFormData((prev) => ({
//       ...prev,
//       templateText: `${prev.templateText} {{${newVar}}}`,
//     }));
//   };

//   const insertVariable = (varName) => {
//     const newText = `${formData.templateText} {{${varName}}}`;
//     setFormData({ ...formData, templateText: newText });
//   };

//   const handleVariableValueChange = (name, value) => {
//     const updated = [...variables];
//     const idx = updated.findIndex((v) => v.name === name);
//     if (idx > -1) {
//       updated[idx].value = value;
//     } else {
//       updated.push({ name, value });
//     }
//     setVariables(updated);
//   };

//   const renderPreview = () => {
//     let text = formData.templateText;
//     variables.forEach(({ name, value }) => {
//       text = text.replaceAll(`{{${name}}}`, value);
//     });
//     return text;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (isEdit) {
//         await axios.put(`${API_URL}/api/smsTemplates/${editId}`, formData, {
//           headers,
//         });
//         toast.success("Template updated successfully!");
//       } else {
//         await axios.post(`${API_URL}/api/smsTemplates`, formData, { headers });
//         toast.success("Template added successfully!");
//       }
//       fetchTemplates();
//       closeModal();
//     } catch (err) {
//       console.error("Submit error:", err);
//       toast.error("Failed to save template");
//     }
//   };

//   const handleEdit = (template) => {
//     setFormData(template);
//     setEditId(template.mesaageId);
//     setIsEdit(true);
//     setAvailableVariables([]);
//     setVariables([]);
//     setModalOpen(true);
//   };

//   const handleDeleteClick = (mesaageId) => {
//     setDeleteId(mesaageId);
//     setConfirmDeleteModal(true);
//   };

//   const confirmDelete = async () => {
//     try {
//       await axios.delete(`${API_URL}/api/smsTemplates/${deleteId}`, {
//         headers,
//       });
//       toast.success("Template deleted successfully!");
//       fetchTemplates();
//       setConfirmDeleteModal(false);
//       setDeleteId(null);
//     } catch (err) {
//       console.error("Delete error:", err);
//       toast.error("Failed to delete template");
//     }
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//     setFormData({
//       senderId: "",
//       templateId: "",
//       templateType: "",
//       templateText: "",
//       companyId: companyId,
//     });
//     setAvailableVariables([]);
//     setVariables([]);
//     setIsEdit(false);
//     setEditId(null);
//   };

//   return (
//     <div className="p-2 dark:bg-gray-900 dark:text-white">
//       {/* Header */}
//       <div className="flex flex-col md:flex-row items-center justify-between gap-2 mb-4">
//         <h1 className="text-xl font-extrabold tracking-tight text-slate-800 dark:text-slate-100 flex items-center gap-2">
//           SMS Template
//           </h1>
//         <button
//           onClick={() => setModalOpen(true)}
//           className="bg-blue-600 text-white px-3 py-2 rounded-full hover:bg-blue-700"
//         >
//           <FaPlus />
//         </button>
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto ">
//         <table className="min-w-full border divide-y divide-gray-200 shadow-lg overflow-hidden text-sm">
//           <thead className="bg-gray-100 text-gray-700 text-sm uppercase dark:bg-gray-800 dark:text-white">
//             <tr>
//               <th className="p-2 text-left font-medium">Sender Id</th>
//               <th className="p-2 text-left font-medium">Template Id</th>
//               <th className="p-2 text-left font-medium">Type</th>
//               <th className="p-2 text-left font-medium">Text</th>
//               <th className="p-2 text-left font-medium">Actions</th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-100 text-sm">
//             {templates.map((tpl) => (
//               <tr
//                 key={tpl.id}
//                 className="hover:bg-gray-50 transition dark:bg-gray-800 dark:text-white"
//               >
//                 <td className="p-2">{tpl.senderId}</td>
//                 <td className="p-2">{tpl.templateId}</td>
//                 <td className="p-2">{tpl.templateType}</td>
//                 <td className="p-2 max-w-sm overflow-hidden truncate">
//                   {tpl.templateText}
//                 </td>
//                 <td className="p-2 space-x-3 flex items-center">
//                   <button
//                     onClick={() => handleEdit(tpl)}
//                     className="text-yellow-500 hover:text-yellow-600"
//                   >
//                     <FaEdit />
//                   </button>
//                   <button
//                     onClick={() => handleDeleteClick(tpl.mesaageId)}
//                     className="text-red-500 hover:text-red-600"
//                   >
//                     <FaTrash />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Modal */}
//       {modalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm px-4 ">
//           <div className="relative bg-white rounded-lg w-full max-w-2xl shadow-lg max-h-[90vh] flex flex-col overflow-hidden dark:bg-gray-700 dark:text-white">
//             {/* Sticky Header */}
//             <div className="sticky top-0 z-20 bg-white flex justify-between items-center border-b border-gray-200 px-6 py-4 dark:bg-gray-700 dark:text-white">
//               <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">
//                 {isEdit ? "Edit SMS Template" : "Add SMS Template"}
//               </h2>
//               <button
//                 onClick={closeModal}
//                 className="text-gray-500 hover:text-gray-700 transition"
//                 aria-label="Close modal"
//               >
//                 <XMarkIcon className="h-6 w-6" />
//               </button>
//             </div>

//             {/* Scrollable Content */}
//             <div className="overflow-y-auto px-6 py-4">
//               <form onSubmit={handleSubmit} className="space-y-5">
//                 {/* Sender ID */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//                     Sender ID
//                   </label>
//                   <input
//                     type="text"
//                     placeholder="Sender ID"
//                     value={formData.senderId}
//                     onChange={(e) =>
//                       setFormData({ ...formData, senderId: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border border-gray-300 rounded focus:ring focus:ring-blue-200 dark:bg-gray-700 dark:text-white"
//                     required
//                   />
//                 </div>

//                 {/* Template ID */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//                     Template ID
//                   </label>
//                   <input
//                     type="text"
//                     placeholder="Template ID"
//                     value={formData.templateId}
//                     onChange={(e) =>
//                       setFormData({ ...formData, templateId: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border border-gray-300 rounded focus:ring focus:ring-blue-200 dark:bg-gray-700 dark:text-white"
//                     required
//                   />
//                 </div>

//                 {/* Template Type */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//                     Template Type
//                   </label>
//                   <input
//                     type="text"
//                     placeholder="Template Type"
//                     value={formData.templateType}
//                     onChange={(e) =>
//                       setFormData({ ...formData, templateType: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border border-gray-300 rounded focus:ring focus:ring-blue-200 dark:bg-gray-700 dark:text-white"
//                     required
//                   />
//                 </div>

//                 {/* Template Text */}
//                 <div>
//                   <div className="flex justify-between items-center mb-1">
//                     <label className="text-sm font-medium text-gray-700 dark:text-white">
//                       Template Text
//                     </label>
//                     <button
//                       type="button"
//                       onClick={addVariable}
//                       className="flex items-center text-sm text-blue-600 hover:underline"
//                     >
//                       <FiPlus className="mr-1" /> Add Variable
//                     </button>
//                   </div>
//                   <textarea
//                     name="templateText"
//                     value={formData.templateText}
//                     onChange={(e) =>
//                       setFormData({ ...formData, templateText: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border border-gray-300 rounded text-sm focus:ring focus:ring-blue-200 dark:bg-gray-700 dark:text-white"
//                     rows="5"
//                     required
//                   />
//                   <div className="mt-2 flex flex-wrap gap-2">
//                     {availableVariables.map((varName) => (
//                       <button
//                         key={varName}
//                         type="button"
//                         onClick={() => insertVariable(varName)}
//                         className="px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded text-sm font-mono dark:bg-gray-700 dark:text-white dark:border-white"
//                       >
//                         {`{{${varName}}}`}
//                       </button>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Variable Values */}
//                 {availableVariables.length > 0 && (
//                   <div className="bg-gray-50 p-4 rounded border border-gray-200 dark:bg-gray-700 dark:text-white">
//                     <h3 className="text-sm font-semibold mb-3 text-gray-700 dark:text-white">
//                       Variable Values
//                     </h3>
//                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 dark:bg-gray-700 dark:text-white">
//                       {availableVariables.map((varName) => (
//                         <div key={varName}>
//                           <label className="block text-xs text-gray-600 mb-1 dark:bg-gray-700 dark:text-white">{`{{${varName}}}`}</label>
//                           <input
//                             type="text"
//                             value={
//                               variables.find((v) => v.name === varName)
//                                 ?.value || ""
//                             }
//                             onChange={(e) =>
//                               handleVariableValueChange(varName, e.target.value)
//                             }
//                             className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring focus:ring-blue-200 dark:bg-gray-700 dark:text-white"
//                             placeholder={`Value for {{${varName}}}`}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* Preview */}
//                 <div className="bg-gray-50 p-4 rounded border border-gray-200 dark:bg-gray-700 dark:text-white">
//                   <h3 className="text-sm font-semibold mb-2 text-gray-700 dark:text-white">
//                     Preview
//                   </h3>
//                   <div className="p-2 bg-white border border-gray-200 rounded min-h-[64px] text-sm whitespace-pre-wrap dark:bg-gray-700 dark:text-white">
//                     {renderPreview() || (
//                       <span className="text-gray-400">
//                         Preview will appear here
//                       </span>
//                     )}
//                   </div>
//                 </div>

//                 {/* Footer Buttons */}
//                 <div className="flex justify-end gap-3 pt-4">
//                   <button
//                     type="button"
//                     onClick={closeModal}
//                     className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="px-5 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                   >
//                     {isEdit ? "Update" : "Create"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}

//       {confirmDeleteModal && (
//   <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center">
//     <div className="bg-white p-6 rounded-lg shadow-lg dark:bg-gray-700 dark:text-white">
//       <h2 className="text-lg font-semibold mb-4">Confirm Deletion</h2>
//       <p className="mb-6">Are you sure you want to delete this SMS Template?</p>
//       <div className="flex justify-end gap-4">
//         <button
//           onClick={() => setConfirmDeleteModal(false)}
//           className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500"
//         >
//           Cancel
//         </button>
//         <button
//           onClick={confirmDelete}
//           className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
//         >
//           Delete
//         </button>
//       </div>
//     </div>
//   </div>
// )}

//     </div>
//   );
// };

// export default SmsTemplate;


import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { toast } from "react-toastify";

const SmsTemplate = () => {
  const { user } = useContext(AuthContext);
  const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;

  const [templates, setTemplates] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({
    senderId: "",
    templateId: "",
    templateType: "",
    templateText: "",
    companyId: companyId,
  });
  const [availableVariables, setAvailableVariables] = useState([]);
  const [variables, setVariables] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);

  const headers = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };

  const fetchTemplates = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/api/smsTemplates/company/${companyId}`,
        { headers }
      );
      setTemplates(res.data.smsTemplates);
    } catch (err) {
      console.error("Error fetching templates:", err);
    }
  };

  useEffect(() => {
    fetchTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addVariable = () => {
    const newVar = `var${availableVariables.length + 1}`;
    setAvailableVariables((prev) => [...prev, newVar]);
    setFormData((prev) => ({
      ...prev,
      templateText: `${prev.templateText} {{${newVar}}}`,
    }));
  };

  const insertVariable = (varName) => {
    const newText = `${formData.templateText} {{${varName}}}`;
    setFormData({ ...formData, templateText: newText });
  };

  const handleVariableValueChange = (name, value) => {
    const updated = [...variables];
    const idx = updated.findIndex((v) => v.name === name);
    if (idx > -1) {
      updated[idx].value = value;
    } else {
      updated.push({ name, value });
    }
    setVariables(updated);
  };

  const renderPreview = () => {
    let text = formData.templateText;
    variables.forEach(({ name, value }) => {
      text = text.replaceAll(`{{${name}}}`, value);
    });
    return text;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEdit) {
        await axios.put(`${API_URL}/api/smsTemplates/${editId}`, formData, {
          headers,
        });
        toast.success("Template updated successfully!");
      } else {
        await axios.post(`${API_URL}/api/smsTemplates`, formData, { headers });
        toast.success("Template added successfully!");
      }
      fetchTemplates();
      closeModal();
    } catch (err) {
      console.error("Submit error:", err);
      toast.error("Failed to save template");
    }
  };

  const handleEdit = (template) => {
    setFormData(template);
    setEditId(template.mesaageId);
    setIsEdit(true);
    setAvailableVariables([]);
    setVariables([]);
    setModalOpen(true);
  };

  const handleDeleteClick = (mesaageId) => {
    setDeleteId(mesaageId);
    setConfirmDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${API_URL}/api/smsTemplates/${deleteId}`, {
        headers,
      });
      toast.success("Template deleted successfully!");
      fetchTemplates();
      setConfirmDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      console.error("Delete error:", err);
      toast.error("Failed to delete template");
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setFormData({
      senderId: "",
      templateId: "",
      templateType: "",
      templateText: "",
      companyId: companyId,
    });
    setAvailableVariables([]);
    setVariables([]);
    setIsEdit(false);
    setEditId(null);
  };

  return (
    <div className="max-w-6xl mx-auto mt-8 mb-4 max-h-[85vh] overflow-y-auto bg-white dark:bg-gray-900 p-6 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 dark:border-gray-800">
      {/* Header */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6 border-b border-gray-100 dark:border-gray-800 pb-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-[#673AB7] dark:text-[#8b5cf6] flex items-center gap-2">
            SMS Templates
          </h1>
          <p className="text-sm text-gray-500 mt-1 dark:text-gray-400">Manage your pre-approved message formats.</p>
        </div>
        <button
          onClick={() => setModalOpen(true)}
          className="bg-[#673AB7] text-white px-5 py-2.5 rounded-lg hover:bg-opacity-90 transition-all shadow-md flex items-center font-medium text-sm"
        >
          <FaPlus className="mr-2" /> Add Template
        </button>
      </div>

      {/* Table */}
      <div className="overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-700">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
          <thead className="bg-gray-50 dark:bg-gray-800 text-gray-700 dark:text-gray-200 uppercase text-xs font-semibold">
            <tr>
              <th className="p-4 text-left">Sender Id</th>
              <th className="p-4 text-left">Template Id</th>
              <th className="p-4 text-left">Type</th>
              <th className="p-4 text-left">Text</th>
              <th className="p-4 text-left w-24">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-100 dark:divide-gray-800 text-sm">
            {templates.map((tpl) => (
              <tr
                key={tpl.id || tpl.mesaageId}
                className="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors text-gray-800 dark:text-gray-200"
              >
                <td className="p-4 font-medium">{tpl.senderId}</td>
                <td className="p-4">{tpl.templateId}</td>
                <td className="p-4">
                  <span className="px-2.5 py-1 bg-gray-100 dark:bg-gray-700 rounded-md text-xs font-medium">
                    {tpl.templateType}
                  </span>
                </td>
                <td className="p-4 max-w-sm overflow-hidden truncate" title={tpl.templateText}>
                  {tpl.templateText}
                </td>
                <td className="p-4 space-x-4 flex items-center">
                  <button
                    onClick={() => handleEdit(tpl)}
                    className="text-[#673AB7] hover:text-opacity-80 transition-colors"
                    title="Edit"
                  >
                    <FaEdit size={16} />
                  </button>
                  <button
                    onClick={() => handleDeleteClick(tpl.mesaageId)}
                    className="text-[#F46653] hover:text-opacity-80 transition-colors"
                    title="Delete"
                  >
                    <FaTrash size={16} />
                  </button>
                </td>
              </tr>
            ))}
            {templates.length === 0 && (
              <tr>
                <td colSpan="5" className="p-6 text-center text-gray-500 dark:text-gray-400">
                  No templates found. Click "Add Template" to create one.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Add/Edit Modal */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm px-4">
          <div className="relative bg-white dark:bg-gray-800 rounded-2xl w-full max-w-2xl shadow-2xl max-h-[90vh] flex flex-col overflow-hidden">
            {/* Sticky Header */}
            <div className="sticky top-0 z-20 bg-white dark:bg-gray-800 flex justify-between items-center border-b border-gray-100 dark:border-gray-700 px-6 py-4">
              <h2 className="text-xl font-bold text-[#673AB7] dark:text-[#8b5cf6]">
                {isEdit ? "Edit SMS Template" : "Add SMS Template"}
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-full p-1"
                aria-label="Close modal"
              >
                <XMarkIcon className="h-5 w-5" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="overflow-y-auto px-6 py-5">
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  {/* Sender ID */}
                  <div>
                    <label className="block text-sm font-semibold text-[#673AB7] dark:text-[#8b5cf6] mb-1.5">
                      Sender ID
                    </label>
                    <input
                      type="text"
                      placeholder="e.g., KOTAK"
                      value={formData.senderId}
                      onChange={(e) => setFormData({ ...formData, senderId: e.target.value })}
                      className="w-full px-4 py-2.5 bg-[#EEF2FC] dark:bg-gray-700 border border-transparent focus:border-[#673AB7] rounded-lg outline-none transition-all text-gray-800 dark:text-white text-sm"
                      required
                    />
                  </div>

                  {/* Template ID */}
                  <div>
                    <label className="block text-sm font-semibold text-[#673AB7] dark:text-[#8b5cf6] mb-1.5">
                      Template ID (DLT)
                    </label>
                    <input
                      type="text"
                      placeholder="e.g., 120716..."
                      value={formData.templateId}
                      onChange={(e) => setFormData({ ...formData, templateId: e.target.value })}
                      className="w-full px-4 py-2.5 bg-[#EEF2FC] dark:bg-gray-700 border border-transparent focus:border-[#673AB7] rounded-lg outline-none transition-all text-gray-800 dark:text-white text-sm"
                      required
                    />
                  </div>
                </div>

                {/* Template Type */}
                <div>
                  <label className="block text-sm font-semibold text-[#673AB7] dark:text-[#8b5cf6] mb-1.5">
                    Template Type
                  </label>
                  <input
                    type="text"
                    placeholder="e.g., Transactional, Promotional"
                    value={formData.templateType}
                    onChange={(e) => setFormData({ ...formData, templateType: e.target.value })}
                    className="w-full px-4 py-2.5 bg-[#EEF2FC] dark:bg-gray-700 border border-transparent focus:border-[#673AB7] rounded-lg outline-none transition-all text-gray-800 dark:text-white text-sm"
                    required
                  />
                </div>

                {/* Template Text */}
                <div>
                  <div className="flex justify-between items-center mb-1.5">
                    <label className="text-sm font-semibold text-[#673AB7] dark:text-[#8b5cf6]">
                      Template Text
                    </label>
                    <button
                      type="button"
                      onClick={addVariable}
                      className="flex items-center text-xs font-semibold text-[#673AB7] dark:text-[#8b5cf6] hover:underline"
                    >
                      <FiPlus className="mr-1" /> Add Variable
                    </button>
                  </div>
                  <textarea
                    name="templateText"
                    value={formData.templateText}
                    onChange={(e) => setFormData({ ...formData, templateText: e.target.value })}
                    className="w-full px-4 py-3 bg-[#EEF2FC] dark:bg-gray-700 border border-transparent focus:border-[#673AB7] rounded-lg outline-none transition-all text-gray-800 dark:text-white text-sm"
                    rows="4"
                    placeholder="Dear Customer, your OTP is {#var#}..."
                    required
                  />
                  <div className="mt-2 flex flex-wrap gap-2">
                    {availableVariables.map((varName) => (
                      <button
                        key={varName}
                        type="button"
                        onClick={() => insertVariable(varName)}
                        className="px-2.5 py-1 bg-gray-100 hover:bg-gray-200 dark:bg-gray-600 dark:hover:bg-gray-500 rounded text-xs font-mono text-gray-700 dark:text-gray-200 transition-colors border border-gray-200 dark:border-gray-500"
                      >
                        {`{{${varName}}}`}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Variable Values */}
                {availableVariables.length > 0 && (
                  <div className="bg-gray-50 dark:bg-gray-700/50 p-4 rounded-xl border border-gray-100 dark:border-gray-600">
                    <h3 className="text-sm font-semibold mb-3 text-gray-800 dark:text-white">
                      Test Variable Values
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      {availableVariables.map((varName) => (
                        <div key={varName}>
                          <label className="block text-xs font-medium text-gray-600 dark:text-gray-300 mb-1">{`{{${varName}}}`}</label>
                          <input
                            type="text"
                            value={variables.find((v) => v.name === varName)?.value || ""}
                            onChange={(e) => handleVariableValueChange(varName, e.target.value)}
                            className="w-full px-3 py-2 bg-white dark:bg-gray-600 border border-gray-200 dark:border-gray-500 focus:border-[#673AB7] rounded-lg text-sm outline-none transition-all dark:text-white"
                            placeholder="Sample value"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Preview */}
                <div className="bg-gray-50 dark:bg-gray-700/50 p-4 rounded-xl border border-gray-100 dark:border-gray-600">
                  <h3 className="text-sm font-semibold mb-2 text-gray-800 dark:text-white">
                    Live Preview
                  </h3>
                  <div className="p-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg min-h-[64px] text-sm whitespace-pre-wrap text-gray-800 dark:text-gray-200">
                    {renderPreview() || (
                      <span className="text-gray-400 italic">
                        Message preview will appear here...
                      </span>
                    )}
                  </div>
                </div>

                {/* Footer Buttons */}
                <div className="flex justify-end gap-3 pt-4 border-t border-gray-100 dark:border-gray-700">
                  <button
                    type="button"
                    onClick={closeModal}
                    className="px-5 py-2.5 text-sm font-semibold text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-2.5 text-sm font-semibold text-white bg-[#673AB7] rounded-lg hover:bg-opacity-90 transition-all shadow-md"
                  >
                    {isEdit ? "Update Template" : "Save Template"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {confirmDeleteModal && (
        <div className="fixed inset-0 z-[60] bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-2xl max-w-sm w-full">
            <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 text-[#F46653] mx-auto mb-4">
              <FaTrash className="w-5 h-5" />
            </div>
            <h2 className="text-lg font-bold text-center text-gray-900 dark:text-white mb-2">Delete Template</h2>
            <p className="text-center text-sm text-gray-500 dark:text-gray-400 mb-6">
              Are you sure you want to delete this SMS Template? This action cannot be undone.
            </p>
            <div className="flex justify-center gap-3">
              <button
                onClick={() => setConfirmDeleteModal(false)}
                className="px-5 py-2 text-sm font-semibold text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-5 py-2 text-sm font-semibold text-white bg-[#F46653] rounded-lg hover:bg-opacity-90 transition-colors shadow-md"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SmsTemplate;